import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, PhoneIcon, ClockIcon, TruckIcon } from '@heroicons/react/24/outline';
import InteractiveMap from '../ui/InteractiveMap';

const LocationSection = () => {
  return (
    <section className="py-16 bg-white dark:bg-secondary-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-4">
            <MapPinIcon className="h-5 w-5 mr-1" /> Наше местоположение
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Найдите нас в Уральске
          </h2>
          <p className="text-xl text-gray-600 dark:text-secondary-300 max-w-3xl mx-auto">
            Мы находимся в удобном месте с хорошей транспортной доступностью и бесплатной парковкой
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Карта */}
          <div className="lg:col-span-2">
            <InteractiveMap
              address="г. Уральск, ул. Полевая 1Д, нежилое помещение 1"
              coordinates={{
                latitude: 51.2040,
                longitude: 51.3705
              }}
              companyName="ТОО «KazPolimerPlast»"
              description="Производство полиэтиленовых труб"
              height="h-80"
            />
          </div>

          {/* Информация о местоположении */}
          <div className="space-y-6">
            <div className="bg-gray-50 dark:bg-secondary-800 rounded-xl p-6">
              <div className="flex items-start">
                <MapPinIcon className="h-6 w-6 text-primary-600 mt-1 mr-3 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Адрес</h3>
                  <p className="text-gray-600 dark:text-secondary-300 text-sm leading-relaxed">
                    г. Уральск, ул. Полевая 1Д,<br />
                    нежилое помещение 1<br />
                    Западно-Казахстанская область<br />
                    Республика Казахстан
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 dark:bg-secondary-800 rounded-xl p-6">
              <div className="flex items-start">
                <PhoneIcon className="h-6 w-6 text-primary-600 mt-1 mr-3 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Контакты</h3>
                  <p className="text-gray-600 dark:text-secondary-300 text-sm mb-2">
                    <a href="tel:+77084931267" className="hover:text-primary-600 transition-colors">
                      +7 (708) 493-1267
                    </a>
                  </p>
                  <p className="text-gray-600 dark:text-secondary-300 text-sm">
                    <a href="mailto:info@kazpolimerplast.kz" className="hover:text-primary-600 transition-colors">
                      info@kazpolimerplast.kz
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 dark:bg-secondary-800 rounded-xl p-6">
              <div className="flex items-start">
                <ClockIcon className="h-6 w-6 text-primary-600 mt-1 mr-3 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Режим работы</h3>
                  <div className="text-gray-600 dark:text-secondary-300 text-sm space-y-1">
                    <p>Понедельник - Пятница: 9:00 - 18:00</p>
                    <p>Суббота - Воскресенье: выходной</p>
                    <p className="text-primary-600 font-medium mt-2">
                      Склад работает с 8:00 до 17:00
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-primary-50 to-blue-50 dark:from-primary-900/30 dark:to-blue-900/30 rounded-xl p-6 border border-primary-100 dark:border-primary-800">
              <div className="flex items-start">
                <TruckIcon className="h-6 w-6 text-primary-600 mt-1 mr-3 flex-shrink-0" />
                <div>
                  <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Доставка</h3>
                  <p className="text-gray-600 dark:text-secondary-300 text-sm mb-3">
                    Осуществляем доставку по Западно-Казахстанской области и соседним регионам
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700">
                      Бесплатная парковка
                    </span>
                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-700">
                      Удобный подъезд
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="pt-4">
              <Link
                to="/contacts"
                className="w-full bg-primary-600 text-white py-3 px-6 rounded-lg hover:bg-primary-700 transition-colors font-medium text-center block"
              >
                Подробная контактная информация
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;